module.exports = __webpack_public_path__ + "images/5494c7edd4506e74e25f26ba1852eba7.webp";